import TeamContent from './TeamContent';
export default TeamContent;
